/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

export const ABOUT_PARAGRAPHS = [
  'سکویاها الهام‌بخش رشد و پایداری هستن. ما هم دوست داریم مثل این درخت‌ها در هر شرایطی رشد کنیم و ثبات داشته باشیم.',
  'سال‌ها فعالیت تو باشگاه و استودیو به ما نشون داد که خیلی‌ها انگیزه دارن، اما مسیر رو پیدا نمی‌کنن یا بهش پایبند نمی‌مونن... کمبود وقت، شلوغی باشگاه، برنامه‌های نامناسب، یا تمرین‌هایی که نه نتیجه دارن و نه قابل ادامه‌ان.',
  'برای همین تصمیم گرفتیم این تجربه رو به شکل یه پلتفرم آنلاین دربیاریم؛ جایی که بتونی بدون محدودیت زمانی و مکانی، یه برنامه‌ی اصولی داشته باشی، پیشرفتت رو ببینی و بدون سردرگمی جلو بری.',
]
